export default __webpack_public_path__ + "static/media/sd-signin-image.28ef34d1.jpg";